import React from "react";
import { Grid } from "@material-ui/core";

function CustomObjectFieldTemplate(props) {
  var properties = props.properties;

  return React.createElement(
    Grid,
    { container: true, spacing: 2 },
    properties.map(function (prop) {
      return prop.content;
    })
  );
}

export default CustomObjectFieldTemplate;